import HasWriteAccess from '@app/src/components/HasWriteAccess'
import { AvatarSize } from '@app/src/components/Ui/Avatar'
import CompanyAvatar from '@app/src/pages/ResourceCollection/Collections/CellComponents/CompanyAvatar'
import { resolveCompanyLogoImageUrl } from '@app/src/utils/resolveCompanyLogoImageUrl'
import { LoadingButton } from '@mui/lab'
import { Button, Checkbox, ListItem, ListItemButton, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React from 'react'
import { useIntl } from 'react-intl'
import type { ProviderListItemProps } from '../types'

export const ProviderListItem: React.FC<ProviderListItemProps> = ({
  provider,
  isSelected,
  onSelect,
  onView,
  onConnect,
  isConnecting,
}) => {
  const { formatMessage } = useIntl()

  return (
    <ListItem
      sx={{
        justifyContent: 'space-between',
        borderTop: `1px solid ${alpha('#000', 0.12)}`,
      }}
      disablePadding
    >
      <ListItemButton
        selected={isSelected}
        onClick={onSelect}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Checkbox
            edge="start"
            checked={isSelected}
            onClick={e => {
              e.stopPropagation()
              onSelect()
            }}
            sx={{ ml: -1 }}
          />
          <CompanyAvatar
            organizationName={provider.name || ''}
            imageUrl={resolveCompanyLogoImageUrl(provider)}
            size={AvatarSize.Small}
            sx={{ bgcolor: 'grey.400' }}
          />
          <Typography>{provider.name}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
          <Button
            variant="text"
            onClick={e => {
              e.stopPropagation()
              onView()
            }}
          >
            {formatMessage({ id: 'connectOnlyFlowProvidersModal.actions.view' })}
          </Button>
          <HasWriteAccess>
            <LoadingButton
              variant="outlined"
              onClick={e => {
                e.stopPropagation()
                onConnect()
              }}
              sx={{
                minWidth: 100,
                transition: theme =>
                  theme.transitions.create(['color', 'width'], {
                    duration: theme.transitions.duration.standard,
                  }),
                '&.Mui-disabled': {
                  color: 'text.secondary',
                },
                '& .MuiLoadingButton-loadingIndicator': {
                  position: 'relative',
                  left: -2,
                  marginRight: 1,
                },
                '&.MuiLoadingButton-loading': {
                  width: 120,
                },
              }}
              loading={isConnecting}
            >
              {formatMessage({ id: 'connectOnlyFlowProvidersModal.actions.connect' })}
            </LoadingButton>
          </HasWriteAccess>
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
